module.exports = __webpack_public_path__ + "img/confused.62e4e518.png";